<template>
  <main class="treatment-plan-templates">
    <section>
      <div class="treatment-plan-templates__container">
        <div class="treatment-plan-templates__header">
          <h1 class="treatment-plan-templates__title">
            <span>
              Шаблоны планов лечения
            </span>
          </h1>
          <button
            v-if='hasTemplates'
            class="treatment-plan-templates__add"
            type="button"
            v-on:click="showCreateSidebarTreatmentItem = true"
          >
            Добавить
          </button>
        </div>
        <div class="treatment-plan-templates__table-container">
          <div
            class="treatment-plan-templates__categories"
            v-if="hasCategories && !isAwaitTemplates">
            <div class="treatment-plan-templates__table__head">
              <span>Категории</span>
            </div>
            <div class="treatment-plan-templates__categories__container">
              <category-item
                v-for="category in categories"
                v-bind:has-delete="true"
                v-bind:has-edit="true"
                v-bind:key="category.id"
                v-bind:selected-category="selectedCategoryId"
                v-bind:category="category"
                v-on:select-category="onSelectCategory"
                v-on:delete-category="onShowDeleteCategoryDialog"
                v-on:edit-category="onShowEditCategory"
              />
            </div>
          </div>
          <div
            v-if="hasCategories && !isAwaitTemplates"
            class="treatment-plan-templates__table"
          >
            <div class="treatment-plan-templates__table__head">
              <span>Шаблоны</span>
            </div>
            <div class="treatment-plan-templates__table__body">
              <treatment-plan-template-item
                v-for="(template, index) in templates"
                v-on:on-edit-template="onEditTemplate"
                v-on:on-delete-template="onShowDeleteTemplateDialog"
                v-bind:key="index"
                v-bind:template="template"
              />
            </div>
          </div>
        </div>
        <div
          v-if="!isAwaitTemplates && (!hasCategories || !hasTemplates)"
          class="treatment-plan-templates__message"
        >
          Создайте ваш первый план
          <button
            class="treatment-plan-templates__add"
            type="button"
            v-on:click="showCreateSidebarTreatmentItem = true"
          >
            Создать план
          </button>
        </div>

        <side-slide-transition>
          <confirm-side-dialog
            class="treatment-plan-templates-dialog"
            label="Добавить"
            v-if="showCreateSidebarTreatmentItem"
            v-on:cancel="onCloseCreateSidebar"
          >
            <form-treatment-plan-template-item
              class="treatment-plan-templates-dialog__form"
              v-bind:clinic-service-categories="clinicServiceCategories"
              v-bind:clinic-service-price-lists="clinicServicePriceLists"
              v-bind:treatments-categories="categories"
              v-bind:service-units="serviceUnits"
              v-bind:input-errors="inputErrors"
              v-on:on-create-template="onCreate"
              v-on:on-create-category="onCreateCategory"
              v-on:submit="onCreate"
              v-on:cancel="onCloseCreateSidebar"
            />
          </confirm-side-dialog>
          <confirm-side-dialog
            class="treatment-plan-templates-dialog"
            label="Редактирование шаблона"
            v-if="showEditTreatmentPlanTemplateForm"
            v-on:cancel="onCloseEditTemplateSidebar"
          >
            <form-treatment-plan-template
              class="treatment-plan-templates-dialog__form"
              v-bind:dental-services="clinicServiceCategories"
              v-bind:price-lists="clinicServicePriceLists"
              v-bind:initial-is-print-logo="selectedTemplate.isPrintLogo"
              v-bind:initial-name="selectedTemplate.name"
              v-bind:initial-services="selectedTemplate.services"
              v-bind:initial-stages="selectedTemplate.stages"
              v-bind:service-units="serviceUnits"
              v-bind:input-errors="inputErrors"
              v-bind:treatments-categories="categories"
              v-bind:initial-category-id="selectedTemplate.categoryId"
              v-on:submit="onEdit(selectedTemplate.id, $event)"
              v-on:cancel="onCloseEditTemplateSidebar" />
          </confirm-side-dialog>
          <confirm-side-dialog
            class="treatment-plan-templates-dialog"
            label="Редактирование категории"
            v-if="isShowEditCategorySideBar"
            v-on:cancel="onCloseEditCategorySidebar"
          >
            <form-treatment-plan-template-category-edit
              class="treatment-plan-templates-dialog__form"
              v-bind:initial-name="selectedCategory.name"
              v-bind:initial-id="selectedCategory.id"
              v-bind:input-errors="inputErrors"
              v-on:on-submit="onEditCategory"
              v-on:cancel="onCloseEditCategorySidebar"
            />
          </confirm-side-dialog>
        </side-slide-transition>
        <modal-dialog
          v-model="deleteTemplateDialog"
          title="Вы точно хотите удалить шаблон?"
          with-cross
        >
          <confirm-modal
            confirm-title="Да, удалить"
            cancel-title="Нет"
            v-on:on-confirm="onRemove(selectedTemplateId)"
            v-on:cancel="deleteTemplateDialog = false"
          />
        </modal-dialog>
        <modal-dialog
          v-model="deleteCategoryDialog"
          v-bind:title="`При удалении категории все шаблоны в\u00A0ней будут удалены. Продолжить?`"
          title-center
          max-width="480px"
          with-cross
        >
          <confirm-modal
            confirm-title="Да, удалить"
            cancel-title="Нет"
            v-on:on-confirm="onDeleteCategory(selectedDeleteCategoryId)"
            v-on:on-cancel="deleteCategoryDialog = false"
          />
        </modal-dialog>
      </div>
    </section>
  </main>
</template>
<script>
import FormTreatmentPlanTemplate, { Service, Stage } from '@/components/FormTreatmentPlanTemplate.vue';
import notifierMixin from '@/mixins/notifierMixin';
import ModalDialog from '@/components/ModalDialog.vue';
import ConfirmSideDialog from '@/components/ConfirmSideDialog.vue';
import SideSlideTransition from '@/components/SideSlideTransition.vue';
import TreatmentPlanTemplateItem from '@/components/TreatmentPlanTemplateItem.vue';
import CategoryItem from '@/components/CategoryItem.vue';
import FormTreatmentPlanTemplateItem from '@/components/FormTreatmentPlanTemplateItem.vue';
import FormTreatmentPlanTemplateCategoryEdit from '@/components/FormTreatmentPlanTemplateCategoryEdit.vue';
import ConfirmModal from '@/components/ConfirmModal.vue';

/**
 * @description Раздел шаблонов для плана лечения.
 * @type {Vue}
 */
export default {
  components: {
    ConfirmModal,
    FormTreatmentPlanTemplateCategoryEdit,
    FormTreatmentPlanTemplateItem,
    CategoryItem,
    TreatmentPlanTemplateItem,
    SideSlideTransition,
    ConfirmSideDialog,
    ModalDialog,
    FormTreatmentPlanTemplate,
  },
  async created() {
    await this.fetchCategories();
    this.fetchTemplatesByFirstCategory();
    this.fetchServiceUnits();
    this.fetchServices();
  },
  data() {
    return {
      /**
       * @description Выбранная категория для удаления.
       * @type {String}
       */
      selectedDeleteCategoryId: '',
      /**
       * @description Показывать ли сайд-бар редактирования категории
       * @type {boolean}
       */
      isShowEditCategorySideBar: false,
      /**
       * @description Выбранная категория шаблона лечения
       * @type {string}
       */
      selectedCategoryId: '',
      /**
       * @description Категории клиники.
       * @type {any[]}
       */
      clinicServiceCategories: [],
      /**
       * @description Прайс листы клиники.
       * @type {any[]}
       */
      clinicServicePriceLists: [],
      /**
       * @description Показ диалога удаления шаблона
       * @type {boolean}
       */
      deleteTemplateDialog: false,
      /**
       * @description Показ диалога удаления категории.
       * @type {boolean}
       */
      deleteCategoryDialog: false,
      /**
       * @description Выбранный для удаления шаблон
       * @type {Number}
       */
      selectedTemplateId: 0,
      /**
       * @description Индекс раскрытой панели.
       * @type {number}
       */
      expandedPanelIndex: -1,
      /**
       * @description Единицы измерения.
       * @type {any[]}
       */
      serviceUnits: [],
      /**
       * @description Шаблоны.
       * @type {Array}
       */
      templates: [],
      /**
       * @description Категории плана лечения.
       * @type {Array<PlanCategory>}
       */
      categories: [],
      /**
       * @description Показывать диалоговое окно подсказки.
       * @type {boolean}
       */
      showHintDialog: false,
      /**
       * @description Показывать форму создания элементов шаблона плана лечения.
       * @type {boolean}
       */
      showCreateSidebarTreatmentItem: false,
      /**
       * @description Выбранный шаблон.
       * @type Object
       */
      selectedTemplate: null,
      /**
       * @description Выбранная категория.
       * @type Object
       */
      selectedCategory: null,
      /**
       * @description Показывать форму редактирования шаблона.
       * @type {boolean}
       */
      showEditTreatmentPlanTemplateForm: false,
      inputErrors: {},
      /**
       * @description Ожидание загрузки шаблонов.
       * @type {boolean}
       */
      isAwaitTemplates: true,
    };
  },
  computed: {
    /**
     * @description Имеются категории.
     * @type {boolean}
     */
    hasCategories() {
      return this.categories.length > 0;
    },
    /**
     * @description Имеются шаблоны.
     * @type {boolean}
     */
    hasTemplates() {
      return this.templates.length > 0;
    },
  },
  methods: {
    /**
     * @description Обработать событие закрытия сайд бара редактирования категории.
     * @returns {void}
     */
    onCloseEditCategorySidebar() {
      this.isShowEditCategorySideBar = false;
    },
    /**
     * @description Обработать событие закрытия сайд бара добавления.
     * @returns {void}
     */
    onCloseCreateSidebar() {
      this.showCreateSidebarTreatmentItem = false;
    },
    /**
     * @description Обработать событие закрытия сайд бара редактирования шаблона.
     * @returns {void}
     */
    onCloseEditTemplateSidebar() {
      this.showEditTreatmentPlanTemplateForm = false;
    },
    /**
     * @description Затянуть шаблоны по первой категории.
     * @returns {void}
     */
    fetchTemplatesByFirstCategory() {
      const firstCategory = this.categories[0];
      if (!firstCategory) {
        return;
      }
      this.onSelectCategory(firstCategory.id);
    },
    /**
     * @description Обработать события показа сайд-бара редактирования категории.
     * @param id
     * @returns {void}
     */
    onShowEditCategory(id) {
      this.selectedCategory = this.categories.find((el) => el.id === id);
      this.isShowEditCategorySideBar = true;
    },
    /**
     * @description Обработать событие выбора услуги.
     * @param id
     * @returns {void}
     */
    onSelectCategory(id) {
      this.selectedCategoryId = id;
      this.fetchTemplatesByCategory(id);
    },
    /**
     * @description Затянуть детали услуг
     */
    fetchServiceUnits() {
      this
        .$serviceGateway
        .getDefaultUnits()
        .then((items) => { this.serviceUnits = items; });
    },
    /**
     * @description Затянуть услуги
     */
    fetchServices() {
      const onResponse = ({ categories, priceLists }) => {
        this.clinicServicePriceLists = categories;
        this.clinicServicePriceLists = priceLists;
      };
      this.$planGateway.viewTreatmentPlanFillers().then((result) => result.forEach(onResponse));
    },
    /**
     * @description Запросить категории.
     * @returns {void}
     */
    async fetchCategories() {
      this.isAwaitTemplates = true;
      await this.$planGateway
        .getCategories()
        .then((result) => {
          result.forEach((categories) => {
            this.categories = categories;
            this.isAwaitTemplates = false;
          });
        });
    },
    /**
     * @description Получить шаблоны по категории.
     * @param categoryId {string}
     * @returns {void}
     */
    fetchTemplatesByCategory(categoryId = '') {
      const mapTemplate = (template) => {
        const serviceMapper = (acc, item) => acc.concat([
          new Service(
            acc.length,
            item.getName(),
            item.getId(),
            item.getCount(),
            item.getDentalParts(),
            item.getPrice(),
            item.getTeeth(),
            item.getUnits(),
          ),
        ]);
        const services = template.getServices().reduce(serviceMapper, []);
        return {
          id: template.getId(),
          isPrintLogo: template.getIsPrintLogo(),
          hasTrashed: template.getHasTrashed(),
          name: template.getName(),
          services,
          stages: template.getStages().reduce((acc, item) => acc.concat([
            new Stage(
              acc.length,
              item.getId(),
              item.getName(),
              item.getServices().reduce(serviceMapper, []),
            ),
          ]), []),
          categoryId: template.getCategoryId(),
        };
      };
      this
        .$planGateway
        .getTemplates(categoryId)
        .then((result) => {
          result.forEach((items) => {
            this.templates = items.map(mapTemplate);
            this.isAwaitTemplates = false;
          });
        });
    },

    /**
     * @description Обработать событие создания категории.
     * @returns {void}
     */
    onCreateCategory(request) {
      const onSuccess = (response) => {
        this.notifySuccess(response.title);
        this.showCreateSidebarTreatmentItem = false;
        this.fetchCategories();
        this.onSelectCategory(response.id);
        this.inputErrors = {};
      };
      const onFail = (error) => {
        this.notifyFail(error.title);
        const failurePairs = error.causes.map((cause) => [cause.source, cause.details]);
        this.inputErrors = Object.fromEntries(failurePairs) || {};
      };
      this
        .$planGateway
        .createCategory(request)
        .then((either) => {
          either.fold(onFail, onSuccess);
        });
    },

    /**
     * @description Обработать событие удаления категории.
     * @param id {string}
     * @returns {void}
     */
    onDeleteCategory(id) {
      this.deleteCategoryDialog = false;
      const onSuccess = async (response) => {
        this.notifySuccess(response.title);
        await this.fetchCategories();
        this.fetchTemplatesByFirstCategory();
        this.inputErrors = {};
      };
      const onFail = (error) => {
        this.notifyFail(error.title);
        const failurePairs = error.causes.map((cause) => [cause.source, cause.details]);
        this.inputErrors = Object.fromEntries(failurePairs) || {};
      };
      this
        .$planGateway
        .deleteCategory(id)
        .then((either) => {
          either.fold(onFail, onSuccess);
        });
    },

    /**
     * @description Обработать событие редактирования категории.
     * @param request {TreatmentPlanTemplateCategoryEditRequest}
     * @returns {void}
     */
    onEditCategory(request) {
      const onSuccess = (response) => {
        this.notifySuccess(response.title);
        this.isShowEditCategorySideBar = false;
        this.fetchCategories();
        this.inputErrors = {};
      };
      const onFail = (error) => {
        this.notifyFail(error.title);
        const failurePairs = error.causes.map((cause) => [cause.source, cause.details]);
        this.inputErrors = Object.fromEntries(failurePairs) || {};
      };
      this
        .$planGateway
        .editCategory(request)
        .then((either) => {
          either.fold(onFail, onSuccess);
        });
    },
    /**
     * @description Создание шаблона
     * @param {TemplatePlanRequest} request
     */
    onCreate(request) {
      this
        .$planGateway
        .createTemplate(request.toQuery())
        .then((result) => {
          result.forEach((response) => {
            this.notifySuccess(response.title);
            this.onSelectCategory(response.category_id);
            this.showCreateSidebarTreatmentItem = false;
            this.inputErrors = {};
          });
          result.forEachLeft((error) => {
            this.notifyFail(error.title);
            const failurePairs = error.causes.map((cause) => [cause.source, cause.details]);
            this.inputErrors = Object.fromEntries(failurePairs) || {};
          });
        });
    },
    /**
     * @description Редактирование шаблона
     * @param {number} templateId
     * @param {TemplatePlanRequest} request
     */
    onEdit(templateId, request) {
      this
        .$planGateway
        .editTemplate(request.toQuery(), templateId)
        .then((result) => {
          result.forEach((response) => {
            this.notifySuccess(response.title);
            this.onSelectCategory(response.category_id);
            this.showEditTreatmentPlanTemplateForm = false;
            this.expandedPanelIndex = -1;
            this.inputErrors = {};
          });
          result.forEachLeft((error) => {
            this.notifyFail(error.title);
            const failurePairs = error.causes.map((cause) => [cause.source, cause.details]);
            this.inputErrors = Object.fromEntries(failurePairs) || {};
          });
        });
    },
    /**
     * @description Удаление шаблона
     */
    onRemove(templateId) {
      this.deleteTemplateDialog = false;
      this
        .$planGateway
        .removeTemplate(templateId)
        .then((result) => {
          result.forEach(({ title }) => {
            this.notifySuccess(title);
            this.onSelectCategory(this.selectedCategoryId);
          });
          result.forEachLeft(({ title }) => { this.notifyFail(title); });
        });
    },
    /**
     * @description Отобразить диалог удаления шаблона.
     * @param {Number} templateId
     */
    onShowDeleteTemplateDialog(templateId) {
      this.selectedTemplateId = templateId;
      this.deleteTemplateDialog = true;
    },
    /**
     * @description Отобразить диалог удаления категории.
     * @param {Number} categoryId
     */
    onShowDeleteCategoryDialog(categoryId) {
      this.selectedDeleteCategoryId = categoryId;
      this.deleteCategoryDialog = true;
    },
    /**
     * @description Редактировать выбранный шаблон.
     * @param template
     */
    onEditTemplate(template) {
      this.selectedTemplate = template;
      this.showEditTreatmentPlanTemplateForm = true;
    },
  },
  mixins: [
    notifierMixin,
  ],
  name: 'ClinicPanelTreatmentPlanTemplateList',
};
</script>
<style lang="scss">
@use "@/scss/buttons";
.template-panel .template-panel__remove {
  @include buttons.btn-transparent-remove(1rem);
}
.template-panel .template-panel__title::before {
  content: '\270E';
  margin-right: .5rem;
}
.treatment-plan-templates-dialog {
  &__form {
    padding: 0;
  }
}
.treatment-plan-templates {
  overflow-y: scroll;
  width: 100%;
  &__table-container {
    display: grid;
    grid-template-columns: 280px 1fr;
    gap: 10px;
  }
  &__add {
    @include buttons.btn-blue(100%, 48px, 16px);
    max-width: 200px;
  }
  &__container {
    width: 100%;
    padding: 38px 20px 48px 23px;
  }
  &__header {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 15px 25px;
    margin-bottom: 37px;
  }
  &__title {
    display: flex;
    flex-flow: row wrap;
    align-items: baseline;
    gap: 10px 30px;
    button {
      font-size: 18px;
      font-weight: 500;
      color: #90a0b7;
      &:hover {
        color: #0489E0;
      }
    }
  }
  &__categories {
    width: 280px;
    &__caption {
      font-size: 14px;
      line-height: 17px;
      font-weight: 700;
      border-bottom: 2px solid #0489e0;
      padding: 13px 10px 14px;
    }
    &__container {
      display: flex;
      flex-direction: column;
      gap: 15px;
      width: 280px;
      background: #f2f7fa;
      padding: 20px 10px;
    }
  }
  &__table {
    width: 100%;
    &__head {
      padding-block: 14px;
      padding-inline: 10px 0;
      font-weight: 700;
      border-bottom: 2px solid #0489e0;
    }
    &__row {
      width: 100%;
      padding-inline: 10px 0;
      border-bottom: 1px solid #eaeff3;
      &:hover {
        background: #eaeff3;
      }
    }
    &:has(.row-name + span) {
      .treatment-plan-templates__table__head,
      .treatment-plan-templates__table__row {
        min-width: 750px;
      }
    }
    &__head,
    &__row {
      display: grid;
      grid-template-columns: 1fr 43px 43px;
      align-items: center;
      font-size: 14px;
      line-height: 17px;
      &__button-group {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        align-items: center;
        column-gap: 20px;
        padding-block: 12px;
      }
      &__name {
        text-align: left;
      }
      &__edit {
        @include buttons.btn-pen-edit(100%);
      }
      &__delete {
        @include buttons.btn-cross-remove(100%);
      }
    }
  }
  &__message {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    flex-direction: column;
    gap: 20px;
    color: var(--action-color);
    font-size: 24px;
    cursor: default;
  }
}
@media screen and (max-width: 610px) {
  .treatment-plan-templates {
    &__container {
      padding: 38px 10px 140px;
    }
  }
}
</style>
